<!-- Particles.js is a JavaScript library made by Vincent Garreau: http://vincentgarreau.com/particles.js/ -->
<template lang="pug">
  div#particles-js
</template>


<script>
  export default {
    name: 'ParticlesJS',

    mounted () {
      require('particles.js')
      this.$nextTick(() => {
        this.initParticlesJS()
      })
    },

    methods: {
      initParticlesJS () {
        /* eslint-disable */
        particlesJS('particles-js', {
          'particles': {
            'number': {
              'value': 4,
              'density': {
                'enable': true,
                'value_area': 40
              }
            },
            'color': {
              'value': '#141417'
            },
            'shape': {
              'type': 'triangle',
              'stroke': {
                'width': 0,
                'color': '#ffffff'
              },
              'polygon': {
                'nb_sides': 4
              },
              'image': {
                'src': '',
                'width': 100,
                'height': 100
              }
            },
            'opacity': {
              'value': 0.33,
              'random': false,
              'anim': {
                'enable': false,
                'speed': 1,
                'opacity_min': 0.1,
                'sync': false
              }
            },
            'size': {
              'value': 2,
              'random': true,
              'anim': {
                'enable': false,
                'speed': 90,
                'size_min': 0.1,
                'sync': false
              }
            },
            'line_linked': {
              'enable': true,
              'distance': 120,
              'color': '#0044db',
              'opacity': 0.2,
              'width': 2
            },
            'move': {
              'enable': true,
              'speed': 2,
              'direction': 'none',
              'random': false,
              'straight': false,
              'out_mode': 'out',
              'bounce': false,
              'attract': {
                'enable': false,
                'rotateX': 600,
                'rotateY': 1200
              }
            }
          },
          'interactivity': {
            'detect_on': 'window',
            'events': {
              'onhover': {
                'enable': true,
                'mode': 'grab'
              },
              'onclick': {
                'enable': false,
                'mode': 'push'
              },
              'resize': true
            },
            'modes': {
              'grab': {
                'distance': 140,
                'line_linked': {
                  'opacity': 0.2
                }
              },
              'bubble': {
                'distance': 400,
                'size': 40,
                'duration': 2,
                'opacity': 8,
                'speed': 3
              },
              'repulse': {
                'distance': 200,
                'duration': 0.4
              },
              'push': {
                'particles_nb': 2
              },
              'remove': {
                'particles_nb': 4
              }
            }
          },
          'retina_detect': true
        })
      }
    }

  }
</script>


<style lang="sass">
  #particles-js
    // z-index: 0
    width: 100%
    height: 100%
    position: FIXED
    top: 0
    left: 0

    .particles-js-canvas-el
      transform: scale(1)
      opacity: 1
      animation: appear 2.4s .75
      animation-fill-mode: forwards

    canvas
      +unselectable
      width: 100%
      height: 100%

  @keyframes appear
    0%
      transform: scale(0)
      opacity: 0
    100%
      transform: scale(1)
      opacity: 1
</style>



// WEBPACK FOOTER //
// src/components/ParticlesJS.vue